<template>
  <div>
    <b-modal size="xl" id="modalProductionOrder" hide-header>
      <template #modal-footer>
        <div style="display: flex; justify-content: space-between; width: 100%">
          <div>
            <button
              class="btnsProductionOrder"
              @click="closeModal('modalProductionOrder')"
            >
              Voltar
            </button>
          </div>

          <div>
            <button
              class="btnsProductionOrder btnConfirm"
              @click="handleSaveOrUpdate"
              :disabled="loadingToSaveOrUpdate"
            >
              <p style="margin: 0; position: relative">
                {{ productionOrder.id ? "Atualizar" : "Salvar" }}

                <b-spinner
                  v-if="loadingToSaveOrUpdate"
                  style="
                    width: 15px;
                    height: 15px;
                    color: gray;
                    position: absolute;
                    right: 10px;
                    top: 10%;
                  "
                />
              </p>
            </button>
          </div>
        </div>
      </template>

      <div>
        <div class="headerProductionOrder">
          <p>P.P Simples Nº {{ productionOrder.numero }}</p>
          <p>
            {{ productionOrderSituationTypes[productionOrder.situacao] }}
            {{
              productionOrder.codReferencia &&
              ` - ${productionOrder.codReferencia}`
            }}
          </p>
          <p>{{ maskCurrency(totals.total || 0) }}</p>
        </div>

        <div style="padding: 0 10px">
          <hr style="margin-top: 0.2rem; margin-bottom: 1rem" />
        </div>
        <div @click="closeModal('modalProductionOrder')" class="closeModal">
          <b-icon-x scale="1.3"></b-icon-x>
        </div>
      </div>

      <div class="contentSections">
        <section class="dataCabecalho">
          <div class="contentItens" style="padding: 0 0 0 5px">
            <p class="titleItens">Cliente</p>
            <p class="itens">
              {{ productionOrderForModal.customerName }}
            </p>
          </div>

          <div class="contentItens" style="align-items: center">
            <p class="titleItens">Funcionário</p>
            <p class="itens">
              {{ productionOrderForModal.employeeName }}
            </p>
          </div>

          <div class="contentItens" style="align-items: center">
            <p class="titleItens">Data inicio</p>
            <p class="itens">
              {{ productionOrder.dataInicio | moment }}
            </p>
          </div>

          <div class="contentItens" style="align-items: center">
            <p class="titleItens">Data fim</p>
            <p class="itens">
              {{ productionOrder.dataFim | moment }}
            </p>
          </div>

          <div class="contentItens" style="align-items: center">
            <p class="titleItens">Data Entrega</p>
            <p class="itens">
              {{ productionOrder.dataEntrega | moment }}
            </p>
          </div>

          <div
            v-if="productionOrder.comissao"
            class="contentItens"
            style="align-items: center"
          >
            <p class="titleItens">Valor Comissão</p>
            <p class="itens">
              {{ maskCurrency(productionOrder.comissao) }}
            </p>
          </div>
        </section>

        <section class="dataSaleItems">
          <div
            style="box-shadow: 0 0 2px 1px #00000029; border-radius: 5px"
            v-if="productionOrderForModal.items['simpleItem'].length"
          >
            <div class="headerCardItems">
              <p>Produtos</p>
              <div class="countItem">
                <p
                  style="
                    font-size: 11px;
                    font-weight: normal;
                    color: white;
                    margin: 0;
                  "
                >
                  {{ productionOrderForModal.items["simpleItem"].length }} item
                </p>
              </div>
            </div>

            <table style="padding: 0 0.5rem">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Observação</th>
                  <th style="text-align: start">Qnt.</th>
                  <th style="text-align: center">Valor</th>
                  <th style="text-align: end">Subtotal</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="orderItemSimple in productionOrderForModal.items[
                    'simpleItem'
                  ]"
                  :key="orderItemSimple.id"
                >
                  <td>{{ orderItemSimple.nome }}</td>
                  <td>{{ orderItemSimple.dadosAdicionais }}</td>
                  <td style="text-align: start">
                    {{ orderItemSimple.quantidade }}
                  </td>
                  <td style="text-align: center">
                    R$ {{ orderItemSimple.valorUnitario }}
                  </td>
                  <td style="text-align: end">
                    {{
                      orderItemSimple.valorTotal.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            style="box-shadow: 0 0 2px 1px #00000029; border-radius: 5px"
            v-if="handleShowTableSquareItems().length"
          >
            <div class="headerCardItems">
              <p>MT2</p>
              <div class="countItem">
                <p
                  style="
                    font-size: 11px;
                    font-weight: normal;
                    color: white;
                    margin: 0;
                  "
                >
                  {{ handleShowTableSquareItems().length }}
                  item
                </p>
              </div>
            </div>

            <table style="padding: 0 0.5rem">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th style="text-align: start">Alt.</th>
                  <th style="text-align: start">Larg.</th>
                  <th style="text-align: start">MT</th>
                  <th style="text-align: start">Qnt.</th>
                  <th style="text-align: start">MT Tot</th>
                  <th style="text-align: center">V. Unit</th>
                  <th style="text-align: end">V. Tot</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="orderItemSquare in handleShowTableSquareItems()"
                  :key="orderItemSquare.id"
                >
                  <td>
                    <div style="display: flex; flex-direction: column">
                      <div style="display: flex">
                        <p>
                          {{ orderItemSquare.nome }}
                        </p>

                        <p
                          v-if="orderItemSquare.ambiente"
                          style="
                            color: gray;
                            font-size: 11px;
                            font-style: italic;
                          "
                        >
                          - {{ orderItemSquare.ambiente }}
                        </p>
                      </div>
                      <p
                        style="color: gray; font-size: 11px; font-style: italic"
                      >
                        {{ orderItemSquare.dadosAdicionais }}
                      </p>
                    </div>
                  </td>
                  <td style="text-align: start">
                    {{ orderItemSquare.altura }}
                  </td>
                  <td style="text-align: start">
                    {{ orderItemSquare.largura }}
                  </td>
                  <td style="text-align: start">
                    {{ orderItemSquare.metragem }}
                  </td>
                  <td style="text-align: start">
                    {{ orderItemSquare.quantidade }}
                  </td>
                  <td style="text-align: start">
                    {{ orderItemSquare.quantidade * orderItemSquare.metragem }}
                  </td>
                  <td style="text-align: center">
                    R$ {{ orderItemSquare.valorUnitario }}
                  </td>
                  <td style="text-align: end">
                    {{
                      orderItemSquare.valorTotal.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            style="box-shadow: 0 0 2px 1px #00000029; border-radius: 5px"
            v-if="handleShowTableSquareItems(true).length"
          >
            <div class="headerCardItems">
              <p>MTL</p>
              <div class="countItem">
                <p
                  style="
                    font-size: 11px;
                    font-weight: normal;
                    color: white;
                    margin: 0;
                  "
                >
                  {{ handleShowTableSquareItems(true).length }}
                  item
                </p>
              </div>
            </div>

            <table style="padding: 0 0.5rem">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th style="text-align: start">Alt.</th>
                  <th style="text-align: start">Larg.</th>
                  <th style="text-align: start">MT</th>
                  <th style="text-align: start">Qnt.</th>
                  <th style="text-align: start">MT Tot</th>
                  <th style="text-align: center">V. Unit</th>
                  <th style="text-align: end">V. Tot</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="orderItemSquare in handleShowTableSquareItems(true)"
                  :key="orderItemSquare.id"
                >
                  <td>
                    <div style="display: flex; flex-direction: column">
                      <div style="display: flex">
                        <p>
                          {{ orderItemSquare.nome }}
                        </p>

                        <p
                          v-if="orderItemSquare.ambiente"
                          style="
                            color: gray;
                            font-size: 11px;
                            font-style: italic;
                          "
                        >
                          - {{ orderItemSquare.ambiente }}
                        </p>
                      </div>
                      <p
                        style="color: gray; font-size: 11px; font-style: italic"
                      >
                        {{ orderItemSquare.dadosAdicionais }}
                      </p>
                    </div>
                  </td>
                  <td style="text-align: start">
                    {{ orderItemSquare.altura }}
                  </td>
                  <td style="text-align: start">
                    {{ orderItemSquare.largura }}
                  </td>
                  <td style="text-align: start">
                    {{ orderItemSquare.metragem }}
                  </td>
                  <td style="text-align: start">
                    {{ orderItemSquare.quantidade }}
                  </td>
                  <td style="text-align: start">
                    {{ orderItemSquare.quantidade * orderItemSquare.metragem }}
                  </td>
                  <td style="text-align: center">
                    R$ {{ orderItemSquare.valorUnitario }}
                  </td>
                  <td style="text-align: end">
                    {{
                      orderItemSquare.valorTotal.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            style="box-shadow: 0 0 2px 1px #00000029; border-radius: 5px"
            v-if="productionOrderForModal.items['serviceItem'].length"
          >
            <div class="headerCardItems">
              <p>Serviços</p>

              <div class="countItem">
                <p
                  style="
                    font-size: 11px;
                    font-weight: normal;
                    color: white;
                    margin: 0;
                  "
                >
                  {{ productionOrderForModal.items["simpleItem"].length }} item
                </p>
              </div>
            </div>

            <table style="padding: 0 0.5rem">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Observação</th>
                  <th style="text-align: start">Quantidade</th>
                  <th style="text-align: center">Valor</th>
                  <th style="text-align: end">Subtotal</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="orderItemService in productionOrderForModal.items[
                    'serviceItem'
                  ]"
                  :key="orderItemService.id"
                >
                  <td>
                    <p style="font-size: 11px">{{ orderItemService.nome }}</p>
                  </td>

                  <td style="text-align: start">
                    {{ orderItemService.dadosAdicionais }}
                  </td>
                  <td style="text-align: start">
                    {{ orderItemService.quantidade }}
                  </td>
                  <td style="text-align: center">
                    R$ {{ orderItemService.valorUnitario }}
                  </td>
                  <td style="text-align: end">
                    {{
                      orderItemService.valorTotal.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <b-row style="margin: 30px 0">
          <div class="contentDataTotals">
            <div class="contentTotals">
              <span class="boxTotals">
                <p>Subtotal (R$)</p>
                <p class="colorItens">{{ maskCurrency(totals.totalItems) }}</p>
              </span>

              <span class="boxTotals">
                <p>Desconto (R$)</p>
                <p class="colorItens">
                  {{ maskCurrency(totals.totalDiscount) }}
                </p>
              </span>

              <span class="dashed"></span>

              <span class="boxTotals contentFreteTotals">
                <p>Frete (R$)</p>
                <p class="frete">{{ maskCurrency(totals.frete) }}</p>
              </span>

              <span class="boxTotals contentFreteTotals">
                <p>Outros (R$)</p>
                <p class="frete">{{ maskCurrency(totals.otherValues) }}</p>
              </span>

              <span class="boxTotals totals">
                <p>Total (R$)</p>
                <p class="colorItens">{{ maskCurrency(totals.total) }}</p>
              </span>
            </div>
          </div>
        </b-row>

        <div class="generalContent m-0">
          <div>
            <p class="titleObs">Observações Gerais</p>
            <div class="descriptions">
              {{ productionOrder.observacoes }}
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="modal-center-production-order"
        size="md"
        hide-footer
        hide-header
        centered
        title="Emitir"
        @hidden="closePrint"
      >
        <div>
          <h6 class="titleModal">
            {{
              !isOtherPrints ? "Deseja imprimir ?" : "Modelos para impressão"
            }}
          </h6>
          <div class="btnModal" v-if="!isOtherPrints">
            <button class="btnContentReceive" @click="showOtherPrints">
              Impressões
            </button>

            <button class="btnContent" @click="generateSaleSquareMeter">
              Gerar Venda MT2
            </button>
          </div>

          <div class="rowContainer" v-else>
            <span>
              <b-icon-calendar-week></b-icon-calendar-week> Selecione um
              modelo:</span
            >
            <div class="rowContent mt-3">
              <div
                class="containerRadio"
                v-for="(modelPrint, idx) in modelsPrints"
                :key="idx"
              >
                <label @click="selectTypeReport(modelPrint.type)">
                  <input
                    type="radio"
                    name="radio"
                    :checked="modelPrint.value"
                  />
                  <span>{{ modelPrint.text }}</span>
                </label>
              </div>
            </div>

            <div
              class="rowContent"
              style="justify-content: flex-end; padding: 0"
            >
              <button class="btnPrint" @click="printReportSelect">
                Imprimir
              </button>
            </div>
          </div>

          <div v-if="isOtherPrints" class="rowContent mt-3" style="padding: 0">
            <span class="contentClosePrint" @click="closePrint">
              <b-icon-arrow-left scale="1.5" />
              <p>Voltar</p>
            </span>
          </div>

          <a
            class="rejectModal"
            v-if="!spinLoading && !isOtherPrints"
            @click="startNewProductionOrder"
            >Não, Obrigado! Iniciar nova P.P simples</a
          >
        </div>
        <Loading v-if="spinLoading" class="spin" />
      </b-modal>
    </b-modal>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import moment from "moment";

import Loading from "../Loading/Loading.vue";

import ServiceProductionOrder from "../../services/serviceProductionOrder";
import { ValidadeProductionOrder } from "../../validators/productionOrder";
import { E_TypesReports } from "../../utils/enums/reports/ProductionOrder";

import DefaultLogo from "../../assets/LogoTeste.jpeg";
import print from "../../reports/productionOrder";

export default {
  components: {
    Loading,
  },
  props: {
    productionOrder: {
      type: Object,
    },
    totals: {
      type: Object,
    },
    productionOrderForModal: {
      type: Object,
    },
    paymentsDataInfo: {
      type: Object,
    },
    numberSale: {
      type: [Number, String],
    },
  },
  data() {
    return {
      spinLoading: false,
      defaultLogo: DefaultLogo,
      productsSale: {},
      isOtherPrints: false,
      typeReportSelected: E_TypesReports.simple,
      productionOrderSituationTypes: {
        pendente: "Pendente",
        aprovado: "Aprovado",
        em_separacao: "Em separação",
        producao: "Produção",
        pronta_entrega: "Pronta entrega",
        finalizado: "Finalizado",
        cancelado: "Cancelado",
        pausado: "Pausado",
      },
      modelsPrints: [
        {
          text: "Padrão",
          value: true,
          type: E_TypesReports.simple,
        },
      ],
      loadingToSaveOrUpdate: false,
    };
  },
  methods: {
    ...mapMutations(["SET_SALE_SQUARE_METER_ID"]),
    async handleSaveOrUpdate() {
      this.productionOrder.id ? this.update() : this.save();
    },

    async save() {
      try {
        this.loadingToSaveOrUpdate = true;
        const isValid = ValidadeProductionOrder(this.productionOrder);
        if (isValid && Object.keys(isValid).length) {
          return this.$toast.open({
            message: isValid.message,
            type: "info",
          });
        }

        const result = await ServiceProductionOrder.save(this.productionOrder);

        this.productionOrder.id = result.id;
        this.productionOrder.numero = result.number;

        this.$toast.open({
          message: "Ordem de produção simples registrada!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um problema ao salvar",
          type: "info",
        });
      } finally {
        this.loadingToSaveOrUpdate = false;
        this.openModals("modal-center-production-order");
      }
    },

    async update() {
      try {
        this.loadingToSaveOrUpdate = true;
        const isValid = ValidadeProductionOrder(this.productionOrder);
        if (isValid && Object.keys(isValid).length) {
          return this.$toast.open({
            message: isValid.message,
            type: "info",
          });
        }

        await ServiceProductionOrder.update(this.productionOrder);

        this.$toast.open({
          message: "Ordem de produção simples atualizada!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao atualizar",
          type: "info",
        });
      } finally {
        this.loadingToSaveOrUpdate = false;
        this.openModals("modal-center-production-order");
      }
    },

    async generateSaleSquareMeter() {
      try {
        const saleSquareMeterId =
          await ServiceProductionOrder.generateSaleSquareMeter(
            this.productionOrder.id
          );

        this.goToSaleSquareMeter(saleSquareMeterId);
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao gerar venda MT2",
          type: "info",
        });
      }
    },

    goToSaleSquareMeter(saleSquareMeterId) {
      this.SET_SALE_SQUARE_METER_ID(saleSquareMeterId);

      this.$toast.open({
        message: "Venda MT2 gerada com sucesso!",
        type: "success",
      });

      this.$router.push({
        path: "/vendas-mt",
      });
    },

    printReportSelect() {
      if (!this.productionOrder.id) return;

      print(this.typeReportSelected, this.productionOrder.id);
    },

    showOtherPrints() {
      this.isOtherPrints = !this.isOtherPrints;
    },

    visualizarNfe(danfe) {
      window.open(danfe, "_blank", "width=700, height=800, top=500, left=500");
    },

    maskCurrency(valor, locale = "pt-BR") {
      if (!valor) {
        valor = 0;
      }
      return parseFloat(valor).toLocaleString(locale, {
        style: "currency",
        currency: "BRL",
      });
    },

    selectTypeReport(typeReport) {
      this.typeReportSelected = typeReport;
    },

    closePrint() {
      this.isOtherPrints = false;
    },

    startNewProductionOrder() {
      this.$emit("clearAllProductionOder");
      this.$bvModal.hide("modal-center-production-order");
      this.closeModal("modalProductionOrder");
    },

    handleCalculateTotalProdInTable(prod) {
      let newTotalValue = 0;

      if (this.productionOrder.tipoDesconto === "Porcentagem") {
        const result = (prod.valorTotal * (prod.desconto / 100)).toFixed(2);

        newTotalValue = parseFloat(prod.valorTotal - result);
      } else {
        newTotalValue = prod.valorTotal - prod.desconto;
      }

      return this.maskCurrency(newTotalValue);
    },

    openModals(name) {
      this.$bvModal.show(name);
    },

    closeModal(name) {
      this.$bvModal.hide(name);
    },

    handleShowTableSquareItems(isLinear = false) {
      return this.productionOrderForModal.items["squareMeterItem"].filter(
        (item) => (!isLinear ? !item.linear : item.linear)
      );
    },
  },
  computed: {
    ...mapState({
      saleId: (state) => state.saleId,
    }),
  },

  filters: {
    moment(data) {
      if (data) return moment(data).format("DD/MM/YYYY");

      return "--";
    },
  },
};
</script>

<style scoped>
.footerBtn {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}

thead th {
  border-bottom: 1px solid #d5d3d3;
  color: #afadad;
  font-size: 11px;
  font-weight: normal;
}

td {
  color: black;
  font-size: 11px;
}

.dataSaleItems {
  font-size: 14px;
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

table {
  border-collapse: separate;
  border-spacing: 0 4px;
  width: 100%;
}

.btnsActions {
  width: 150px;
  font-size: 18px;
  margin-top: 0;
  background-color: #0fbf4d;
}

.btnSaveAndSendLeaf {
  width: 200px;
  font-size: 18px;
  margin-top: 0;
  background-color: #00395d;
}

.summaryTitle h5 {
  font-family: Arial, Helvetica, sans-serif;

  color: #00486e;
}

.contentSummary {
  display: flex;
  flex-direction: column;
}

.headerCardItems {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: #f7f7f7;
  border-radius: 5px 5px 0 0;
}

.headerCardItems p {
  font-weight: 600;
  font-size: 12px;
}

.countItem {
  border-radius: 50px;
  background-color: #000000c9;
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
}

.contentSummary p {
  margin-bottom: 5px;
}

.itensSummary {
  display: flex;
  justify-content: space-between;
}

.contentTotals {
  width: 370px;
  display: flex;
  flex-direction: column;
  text-align: right;
  align-items: flex-end;
  font-size: 14px;
  gap: 5px;
}

.boxTotals {
  display: flex;
  align-items: center;
  gap: 30px;
  color: #666360;
}

.dashed {
  border-bottom: 1px dashed #b1aaa5;
  width: 100%;
  margin: 10px 0;
  cursor: auto;
}

.boxTotals {
  display: flex;
  align-items: center;
  cursor: auto;
}

.boxTotals .colorItens {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  outline: none;
  padding-right: 5px;
  background-color: #f2f3f3;
  border-radius: 5px;
  height: 30px;
  width: 177px;
}

.totals {
  font-size: 13px !important;
  color: #666360 !important;
  font-weight: 600;
}

.contentFreteTotals .frete {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  outline: none;
  padding-right: 5px;
  background-color: #f2f3f3;
  border-radius: 5px;
  height: 30px;
  width: 177px;
}

.dataCabecalho {
  width: 100%;
  display: flex;
  background-color: #f7f7f7;
  gap: 20px;
  border-radius: 4px;
}

.contentItens {
  display: flex;
  flex-direction: column;
  width: 30%;
}

.titleItens {
  color: #afadad;
  font-size: 12px;
}

.itens {
  color: black;
  font-size: 12px;
}

.contentSections {
  display: flex;
  flex-direction: column;
  padding: 0 10px;
}

.titleModal {
  font-size: 12px;
  border-bottom: 1px solid #e6e7e8;
}

.btnModal {
  margin-top: 10px;
  margin-bottom: 20px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #00486e;
  border-radius: 3px;
  width: 30%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #00486e;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #00486e;
  border-radius: 3px;
  width: 30%;
  height: 28px;
  position: relative;
  color: #00486e;
  background: white;
}

.btnPrint {
  font-size: 11px;
  border: 1px solid #0fbf4d;
  border-radius: 3px;
  color: #ffffff;
  background: #0fbf4d;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.185);
  transition: ease-in all 0.1s;
}

.btnPrint:hover {
  transition: ease-in all 0.1s;
  background: #0ea241;
}

.contentClosePrint {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.3rem;
  font-size: 11px;
  border-radius: 3px;
  color: #00486e;
  transition: ease-in all 0.1s;
  font-weight: 600;
  cursor: pointer;
}

.contentClosePrint:hover {
  transition: ease-in all 0.1s;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.321);
}

.rejectModal {
  cursor: pointer;
  color: black;
  display: flex;
  justify-content: center;
  font-size: 11px;
  font-style: oblique;
  text-decoration: underline;
}

.spin {
  width: 480px;
  height: 100%;
  top: 0;
}

.headerProductionOrder {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 20px 0 10px;
}

.headerProductionOrder p {
  font-size: 14px !important;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  color: #666360 !important;
}

.closeModal {
  position: absolute;
  top: 0;
  right: 0;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgba(245, 245, 245, 0.476);
  padding: 1px 2px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}

.contentDataTotals {
  width: 100%;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.btnsProductionOrder {
  border-radius: 5px;
  background-color: transparent;
  width: 200px;
  height: 28px;
  border: none;
  border: solid 1px black;
  color: black;
  font-size: 12px;
}

.btnConfirm {
  background-color: whitesmoke;
  border: solid 1px #0fbf4d;
  color: #0fbf4d;
}

.titleObs {
  color: black;
}

.descriptions {
  outline: none;
  padding: 5px;
  background-color: #f2f3f3;
  border-radius: 5px;
  min-height: 30px;
  height: auto;
  width: 100%;
  font-size: 12px;
  white-space: break-spaces;
}

.generalContent {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  width: 100%;
}

.generalContent p {
  font-size: 14px;
}

tr:nth-child(even) {
  background: #f2f3f3;
}

p {
  margin: 0 !important;
}

*::-webkit-scrollbar {
  width: 5px;
  height: 8px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: #00486e;
  border-radius: 2px;
}

.modal-footer {
  padding: 0.25rem;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 5px 10px;
  background: #f9f9f94d;
  margin-top: 20px;
}

.rowContainer span {
  font-weight: 600;
  font-size: 11px;
}

.rowContent {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 0 5px 0;
  gap: 10px;
}

/* INPUT RADIO */

.containerRadio label {
  display: flex;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  margin-bottom: 0.375em;
}

.containerRadio label input {
  position: absolute;
  left: -9999px;
}

.containerRadio label input:checked + span {
  background-color: #f3f2f2;
  color: rgb(0, 0, 0);
}

.containerRadio label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em #00486e;
}

.containerRadio label span {
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 2px;
  transition: 0.25s ease;
}

.containerRadio label span:hover {
  background-color: #e6e6e6;
  border-radius: 2px;
}

.containerRadio label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  margin-right: 0.375em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.1em #00486e;
}

/* INPUT RADIO */

@media (min-width: 768px) and (max-width: 1200px) {
  .contentTotals {
    width: 351px;
    font-size: 11px;
    gap: 0px;
  }
}
</style>